/* ==========================================================================
   LUXE Sticky ATC - mobile-only sticky Add-to-cart bar (PDP v2)

   - Reveal: IntersectionObserver on the real in-flow Add-to-cart button.
     Shows the bar only once that button has scrolled ABOVE the viewport
     (matches the frozen reference: !isIntersecting && rect.top < 0).
   - Action: the bar button proxies a click to the real button, so the theme's
     product-form AJAX add + cart drawer run unchanged and the REAL form
     (product-form-{section}) is submitted with the currently selected variant.
   - Sync: availability/label mirror the real button; variant title + thumbnail
     sync via the theme 'variant-change' pub/sub event. (Price syncs itself
     because the markup reuses the theme's #Price-Alt-{section} update target.)
   - Collisions: when visible, lifts the scroll-to-top button and the live-chat
     launcher clear of the bar so nothing overlaps the pill.
   ========================================================================== */
(function () {
  var bars = document.querySelectorAll('[data-luxe-sticky-atc]');
  if (!bars.length) return;

  var scrollTopBtn = document.querySelector('.luxe-scroll-top');

  Array.prototype.forEach.call(bars, function (bar) {
    var sectionId = bar.getAttribute('data-section-id');
    var realBtn = document.getElementById(bar.getAttribute('data-target-btn'));
    var myBtn = bar.querySelector('[data-luxe-sticky-add]');
    if (!realBtn || !myBtn) return;

    var myLabel = bar.querySelector('[data-luxe-sticky-label]');
    var titleEl = bar.querySelector('[data-luxe-sticky-title]');
    var thumbEl = bar.querySelector('[data-luxe-sticky-thumb]');
    var addLabel = bar.getAttribute('data-add-label') || '';
    var titleSource = bar.getAttribute('data-title-source');

    /* --- Proxy the click to the real in-flow buy button --- */
    myBtn.addEventListener('click', function () {
      if (myBtn.disabled) return;
      realBtn.click();
    });

    /* --- Mirror availability + label from the real button --- */
    function syncState() {
      var disabled = realBtn.hasAttribute('disabled');
      myBtn.disabled = disabled;
      if (myLabel) {
        var realText = (realBtn.textContent || '').trim();
        myLabel.textContent = disabled ? realText : addLabel || realText || myLabel.textContent;
      }
    }
    // product-info.js toggles the real button's `disabled` and its <span> text.
    var stateObserver = new MutationObserver(syncState);
    stateObserver.observe(realBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });
    syncState();

    /* --- Variant title + thumbnail sync via theme pub/sub --- */
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (evt) {
        var d = evt && evt.data;
        if (!d || String(d.sectionId) !== String(sectionId)) return;
        var variant = d.variant;
        if (!variant) return;
        if (titleEl && titleSource === 'variant' && variant.title) {
          titleEl.textContent = variant.title;
        }
        if (thumbEl && variant.featured_image && variant.featured_image.src) {
          thumbEl.src = variant.featured_image.src;
        }
        // real button state updates slightly after this fires; catch it too.
        setTimeout(syncState, 0);
      });
    }

    /* --- Reveal after the in-flow buy button scrolls out of view --- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          toggleFloating(show);
        },
        { threshold: 0 }
      );
      io.observe(realBtn);
    }

    /* --- Keep the floating buttons clear of the bar (no overlap) ---
       scroll-to-top: reuse the theme's own offset class (.luxe-scroll-top--has-sticky-cart).
       live-chat launcher (z 9990, bottom-right): lift it above the measured bar
       height; the scroll-to-top script re-stacks itself above the launcher when
       it moves, so the whole stack stays collision-free. */
    var launcher = document.querySelector('[data-luxe-live-chat-launcher]');
    function toggleFloating(show) {
      if (scrollTopBtn) {
        scrollTopBtn.classList.toggle('luxe-scroll-top--has-sticky-cart', show);
      }
      if (launcher) {
        launcher.style.bottom = show ? (bar.offsetHeight || 64) + 12 + 'px' : '';
      }
    }
  });
})();
